import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gate the whole /admin app subtree on being SIGNED IN (not on being an admin). Per-agent RBAC
 * is enforced deeper: server-side on every endpoint, and client-side by RequireAgent / AdminOnly.
 * Gating this on isAdmin would (and did) lock every non-admin agent user out of the app entirely.
 */
const AdminRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AdminRoute;
